define('home/templates/createDiscussionNav',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"discuss-tile__wrap align align--stretch\">\n<a href=\"/home/discuss/"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.primaryForum : depth0)) != null ? stack1.id : stack1), depth0))
    + "/\" data-action=\"confirm\" alt=\""
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "\"\nclass=\"discuss-tile__link text-center link-gray-dark align align--column\">\n<div class=\"tile__wrapper\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : {},((stack1 = (depth0 != null ? depth0.options : depth0)) != null ? stack1.tile : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>\n<div class=\"discuss-tile__description align align--middle\">\n<p>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.options : depth0)) != null ? stack1.description : stack1), depth0))
    + "</p>\n</div>\n</a>\n</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<img src=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.options : depth0)) != null ? stack1.tile : stack1), depth0))
    + "\" class=\"img-responsive border-radius-sm block__item\" />\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "<div class=\"tile__overlay\">\n<h1 class=\"tile__name\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.name : depth0), depth0))
    + "</h1>\n</div>\n<img src=\"https://media.disquscdn.com/home/blank_tile.png\"\nclass=\"img-responsive border-radius-sm block__item\" />\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<button class=\"text-smaller modal-close -light\" data-dismiss=\"modal\">\n<span class=\"icon-cancel\"></span>\n</button>\n<div class=\"text-center padding-default\">\n<h1 class=\"text-larger text-gray-darker spacing-top spacing-bottom-small\">"
    + alias2(helpers.gettext.call(alias1,"Start a discussion",{"name":"gettext","hash":{},"data":data}))
    + "</h1>\n<p class=\"text-gray\">"
    + alias2(helpers.gettext.call(alias1,"Pick the channel that best fits your discussion topic",{"name":"gettext","hash":{},"data":data}))
    + "</p>\n</div>\n<div class=\"padding-default align align--wrap\">\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.channels : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true})

});
